import type { HomepageSearchFilters } from '@rover/types/src/HomepageSearchFilters';
import { PetType } from '@rover/types/src/Pet';

type PetCounts = {
  dogCount: number;
  catCount: number;
  puppyCount: number;
};

export const resolvePetCounts = (filters: HomepageSearchFilters): PetCounts => {
  const { dogCount, catCount, puppyCount, petType } = filters;

  // Use explicit counter values if any are provided (mobile web)
  const hasExplicitCounts = dogCount || catCount || puppyCount;
  if (hasExplicitCounts) {
    return {
      dogCount: dogCount || 0,
      catCount: catCount || 0,
      puppyCount: puppyCount || 0,
    };
  }

  // Desktop homepage has pet type checkboxes that need to be converted to pet counts (petType.includes)
  let legacyDogCount;
  if (petType?.includes(PetType.DOG) && !petType?.includes(PetType.CAT)) {
    legacyDogCount = 0;
  } else if (petType?.includes(PetType.DOG) && petType.includes(PetType.CAT)) {
    legacyDogCount = 1;
  }
  const legacyCatCount = petType?.includes(PetType.CAT) ? 1 : 0;

  return {
    dogCount: legacyDogCount,
    catCount: legacyCatCount,
    puppyCount: 0,
  };
};
